import './window'
import type { App, Plugin } from 'vue';
import { createPinia } from 'pinia';
export { defineStore, disposePinia, createPinia } from 'pinia';
export { createRouter, createWebHistory, useLink, useRoute, useRouter, type RouteRecordRaw } from 'vue-router';
import { createLocale } from './scripts/translate';
import { useAuthStore, useGeneralStore } from './global';
import filters from './filters';
export { useAuthStore } from './stores/auth';
export { useGeneralStore } from './stores/general';
import Modal from './components/modal/Modal.vue';
import NoData from './components/NoData.vue';
import FilePreview from './components/FilePreview.vue';

export interface Variables {
    input?: any
    inputData?: any
    where?: any
    accessRole?: any
    route?: any
    orderBy?: any
    limit?: any
    page?: any,
    download?: { type?: string, query?: any },
}

// 1. Define an interface for your plugin options
interface PluginOptions {
  greeting?: string;
  debug?: boolean;
}

export const LoadGeneral: Plugin = {
    install(app: App, options: PluginOptions = {}) {
        app.use(createLocale({}))
        app.use(createPinia())

        app.component('modal', Modal)
        app.component('no-data', NoData)
        app.component('preview-file', FilePreview)

        // Restore session on app load
        useAuthStore().restoreSession()
        useGeneralStore().restoreSession()

        // Set global properties
        app.config.globalProperties.$baseUrl = window.location.origin;
        app.config.globalProperties.$currentHost = window.location.host;
        app.config.globalProperties.$prefixUrl = window.$prefixUrl;
        app.config.globalProperties.$moduleName = window.$moduleName;
        app.config.globalProperties.$isDesktop = false;
        app.config.globalProperties.$filter = filters;
        app.config.globalProperties.$isPermitted = window.$isPermitted;
    }
};